import React, { useCallback, useState, useRef, useEffect } from 'react'
import { Modal, Spin, message as $message } from 'antd'

import Form from './Form'
import styles from './index.less'

import { createOperation, updateOperation, queryDockingPeopleConfig } from '@/services/docking'
import { ENABLE } from '../../helper'
import { transValueToData, transDataToValue } from './helper'

const TEXT_MAP = {
    create: {
        title: '新建用户'
    },
    edit: {
        title: '编辑用户'
    }
}

export default ({ visible, formType, dataSource, onOk, onCancel, ...restProps }) => {
    const $this = useRef({
        submitting: false
    })

    const $form = useRef(null)
    const $scroller = useRef(null)
    const [submitting, setSubmitting] = useState(false)
    const [loading, setLoading] = useState(false)
    const [initialValues, setInitialValues] = useState({})

    const scrollTop = () => {
        if ($scroller.current) {
            $scroller.current.scrollTop = 0
        }
    }

    const initCreate = useCallback(() => {
        setInitialValues({ disabled: !ENABLE })
    }, [])

    const initEdit = useCallback(async () => {
        const { id } = dataSource

        const { success, message, data } = await queryDockingPeopleConfig({
            id
        })

        if (success) {
            setInitialValues(transDataToValue(data))
        } else {
            $message.error(message)
        }
    }, [dataSource])

    const init = useCallback(async () => {
        setLoading(true)

        switch (formType) {
            case 'create':
                await initCreate()
                break
            case 'edit':
                await initEdit()
                break
            default:
        }

        setLoading(false)
    }, [formType, initCreate, initEdit])

    useEffect(() => {
        init()
    }, [init])

    useEffect(() => {
        if (visible) {
            scrollTop()
        } else {
            if ($form.current) {
                $form.current.resetFields()
            }
        }
    }, [visible])

    const create = async transValues => {
        try {
            const response = await createOperation(transValues)

            if (response) {
                const { success, message, data } = response

                if (success) {
                    $message.success('保存成功')

                    onOk && onOk(data)
                } else {
                    $message.error(message)
                }
            }
        } catch (e) {
            console.error('catchError', e)
        }
    }

    const edit = async transValues => {
        try {
            const response = await updateOperation(transValues)

            if (response) {
                const { success, message, data } = response

                if (success) {
                    $message.success('修改成功')

                    onOk && onOk(data)
                } else {
                    $message.error(message)
                }
            }
        } catch (e) {
            console.error('catchError', e)
        }
    }

    const handleOk = async () => {
        try {
            const values = await $form.current.validateFields()

            if ($this.current.submitting) {
                return
            }

            $this.current.submitting = true
            setSubmitting(true)

            const transValues = transValueToData(values)

            switch (formType) {
                case 'create':
                    await create(transValues)
                    break
                case 'edit':
                    await edit(transValues)
                    break
                default:
                    console.error('无匹配类型')
            }

            setSubmitting(false)
            $this.current.submitting = false
        } catch (e) {
            console.error('validate', e)
        }
    }

    const text = TEXT_MAP[formType] || {}

    return (
        <Modal
            {...text}
            maskClosable={false}
            visible={visible}
            onCancel={onCancel}
            confirmLoading={submitting}
            onOk={handleOk}
            {...restProps}
        >
            <Spin size="small" spinning={loading}>
                <div ref={$scroller} className={styles.scroller}>
                    <Form ref={$form} formType={formType} initialValues={initialValues} />
                </div>
            </Spin>
        </Modal>
    )
}
